var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTfNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 8.89535V8.24992C17.4167 4.70609 14.5438 1.83325 11 1.83325C7.45619 1.83325 4.58335 4.70609 4.58335 8.24992V8.89535C4.58335 9.66992 4.35408 10.4272 3.92442 11.0716L2.87153 12.651C1.90983 14.0935 2.64401 16.0543 4.31666 16.5105C8.69233 17.7039 13.3077 17.7039 17.6834 16.5105C19.356 16.0543 20.0902 14.0935 19.1285 12.651L18.0756 11.0716C17.646 10.4272 17.4167 9.66992 17.4167 8.89535Z",
    stroke: "#2D1C5B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.4167C7.47544 19.0189 9.09558 20.1667 11 20.1667C12.9044 20.1667 14.5246 19.0189 15.125 17.4167",
    stroke: "#2D1C5B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfNotification);
export default __webpack_public_path__ + "static/media/tf_notification.b51aa5b9352747b027a25b680fa1cf9b.svg";
export { ForwardRef as ReactComponent };